// components/WithdrawModal.jsx (New File)
import React, { useState } from 'react';

const WithdrawModal = ({ isOpen, onClose, balance, onSuccess }) => {
    const [amount, setAmount] = useState('');
    const [method, setMethod] = useState('bKash');
    const [account, setAccount] = useState('');
    const [loading, setLoading] = useState(false);

    if (!isOpen) return null;

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        const token = localStorage.getItem('affiliateToken');

        try {
            const res = await fetch(`${import.meta.env.VITE_API_URL}/affiliate/withdraw`, {
                method: 'POST',
                headers: { 
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}` 
                },
                body: JSON.stringify({ amount, method, account_number: account })
            });
            const data = await res.json();
            if (res.ok) {
                alert("Request Submitted!");
                onSuccess(); // Refresh Dashboard
                onClose();
            } else {
                alert(data.message);
            }
        } catch (error) { alert("Error"); }
        finally { setLoading(false); }
    };

    return (
        <div className="fixed inset-0 bg-black/80 flex items-center justify-center z-50 p-4">
            <div className="bg-gray-800 p-6 rounded-xl w-full max-w-sm border border-gray-700">
                <h3 className="text-xl font-bold text-white mb-4">Withdraw Funds</h3>
                <p className="text-gray-400 text-sm mb-4">Available: ৳{balance}</p>
                
                <form onSubmit={handleSubmit} className="space-y-4">
                    <div>
                        <label className="text-xs font-bold text-gray-500 uppercase">Amount (Min 500)</label>
                        <input type="number" min="500" max={balance} value={amount} onChange={e => setAmount(e.target.value)} className="w-full p-2 bg-gray-700 rounded text-white border border-gray-600" required />
                    </div>
                    <div>
                        <label className="text-xs font-bold text-gray-500 uppercase">Method</label>
                        <select value={method} onChange={e => setMethod(e.target.value)} className="w-full p-2 bg-gray-700 rounded text-white border border-gray-600">
                            <option>bKash</option>
                            <option>Nagad</option>
                            <option>Rocket</option>
                        </select>
                    </div>
                    <div>
                        <label className="text-xs font-bold text-gray-500 uppercase">Account Number</label>
                        <input type="text" value={account} onChange={e => setAccount(e.target.value)} className="w-full p-2 bg-gray-700 rounded text-white border border-gray-600" placeholder="017..." required />
                    </div>
                    
                    <div className="flex gap-3 mt-6">
                        <button type="button" onClick={onClose} className="flex-1 py-2 bg-gray-700 rounded text-white hover:bg-gray-600">Cancel</button>
                        <button type="submit" disabled={loading} className="flex-1 py-2 bg-green-600 rounded text-white font-bold hover:bg-green-700 disabled:opacity-50">
                            {loading ? 'Sending...' : 'Confirm'}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};
export default WithdrawModal;